<template>
  <nav class="flex items-center nav" style="border-top: 1px solid rgb(233 233 233 / 48%); box-sizing: border-box; z-index: 200; background-color: #fff;">
    <div class="flex flex-col flex-1 items-center justify-center" :class="{ active: type === 0 }" @click="onChange(0)">
      <div class="relative icon">
        <div class="icon w-[36px]" :class="{ active: type === 0 }">
          <img src="/static/style/sy.png" class="w-7 h-7 object-contain" :class="{ 'opacity-50': type !== 0 }" />
        </div>
      </div>
      <div class="text-[11px] font-medium relative text" :class="{ active: type === 0 }"> {{ $t('home') || '首页' }} </div>
    </div>
    <div class="flex flex-col flex-1 items-center justify-center" :class="{ active: type === 1 }" @click="onChange(1)">
      <div class="relative icon">
        <div class="icon w-[36px]" :class="{ active: type === 1 }">
          <img src="/static/style/yh.png" class="w-7 h-7 object-contain" :class="{ 'opacity-50': type !== 1 }" />
        </div>
      </div>
      <div class="text-[11px] font-medium relative text" :class="{ active: type === 1 }"> {{ $t('activity') || '优惠' }} </div>
    </div>
    <div class="flex flex-col flex-1 items-center justify-center" :class="{ active: type === 2 }" @click="onChange(2)">
      <div class="relative icon">
        <div class="icon w-[36px]" :class="{ active: type === 2 }">
          <img src="/static/style/ck.png" class="w-7 h-7 object-contain" :class="{ 'opacity-50': type !== 2 }" />
        </div>
      </div>
      <div class="text-[11px] font-medium relative text" :class="{ active: type === 2 }"> {{ $t('deposit') || '存款' }} </div>
    </div>
    <div class="flex flex-col flex-1 items-center justify-center" :class="{ active: type === 3 }" @click="onChange(3)">
      <div class="relative icon">
        <div class="icon w-[36px]" :class="{ active: type === 3 }">
          <img src="/static/style/fx.png" class="w-7 h-7 object-contain" :class="{ 'opacity-50': type !== 3 }" />
        </div>
      </div>
      <div class="text-[11px] font-medium relative text" :class="{ active: type === 3 }"> {{ $t('earn_money') || '赚钱' }} </div>
    </div>
    <div class="flex flex-col flex-1 items-center justify-center" :class="{ active: type === 4 }" @click="onChange(4)">
      <div class="relative icon">
        <div class="icon w-[36px]" :class="{ active: type === 4 }">
          <img src="/static/style/wd.png" class="w-7 h-7 object-contain" :class="{ 'opacity-50': type !== 4 }" />
        </div>
      </div>
      <div class="text-[11px] font-medium relative text" :class="{ active: type === 4 }"> {{ $t('my') || '我的' }} </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'Foot',
  data() {
    return { type: 0 };
  },
  methods: {
    onChange(type) {
      let that = this;
      that.type = type;
      if (type == 0) {
        that.$router.push(`/`);
      }
      if (type == 1) {
        that.$router.push(`/activity`);
      }
      if (type == 2) {
        that.$router.push(`/recharge`);
      }
      if (type == 3) {
        that.$router.push(`/shareMoney`);
      }
      if (type == 4) {
        that.$router.push(`/mine`);
      }
    },
    changPath() {
      let that = this;
      let path = this.$route.path;
      if (path == '/') {
        that.type = 0;
      }
      if (path == '/activity') {
        that.type = 1;
      }
      if (path == '/recharge') {
        that.type = 2;
      }
      if (path == '/shareMoney' || path == '/makeMoney' || path == '/share') {
        that.type = 3;
      }
      if (path == '/mine' || path == '/profile') {
        that.type = 4;
      }
    },
  },
  mounted() {},
  watch: {
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.changPath();
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding-bottom: env(safe-area-inset-bottom);
  background-color: #fff;
  border-top: 1px solid rgba(233, 233, 233, 0.48);
  z-index: 200;
}

.flex {
  display: flex;
}
.flex-col {
  flex-direction: column;
}
.flex-1 {
  flex: 1;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.relative {
  position: relative;
}
.w-\[36px\] {
  width: 36px;
}
.w-7 {
  width: 28px;
}
.h-7 {
  height: 28px;
}
.object-contain {
  object-fit: contain;
}
.opacity-50 {
  opacity: 0.5;
}
.text-\[11px\] {
  font-size: 15px;
}
.font-medium {
  font-weight: 500;
}
.text {
  color: #999;
  margin-top: -6px;
}
.text.active {
  color: #3b82f6;
}
.icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.icon img {
  width: 28px;
  height: 28px;
}
</style>


// WEBPACK FOOTER //
// src/components/libs/Foot.vue